import { Component } from '@angular/core';
import { SubmenuService } from './components/submenu/submenu.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'WgPlatformApp';
  subActive:boolean = false;

  constructor(public submenuService:SubmenuService) 
  {

  }

  ngDoCheck(){
    this.subActive  = this.submenuService.active;
  }
}
